export enum TagType {
  Info = 'info',
  Normal = 'normal',
  Basic = 'basic',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}
